/**
 * Parses a value (string or number) into a number.
 * If `integer` is true, rounds to the nearest whole number.
 * Returns null if the value is not a valid finite number.
 * @param value - The value to parse, can be a string or number.
 * @returns {number | null} - The parsed integer, float, or null if invalid.
 */
export function parseToNumber(
	value: string | number,
	config: { integer?: boolean } = {}
): number | null {
	const { integer = false } = config
	if (typeof value === 'number') {
		if (!Number.isFinite(value)) return null
		return integer ? Math.round(value) : value
	}
	// Matches optional sign, decimals, exponent notation
	const numRegex = /^[+-]?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?$/
	if (!numRegex.test(value)) return null

	const parsed = Number(value)
	if (!Number.isFinite(parsed)) return null
	return integer ? Math.round(parsed) : parsed
}

